import { render, staticRenderFns } from "./ConvergeMerchantId.vue?vue&type=template&id=9faa4f24&"
import script from "./ConvergeMerchantId.vue?vue&type=script&lang=ts&"
export * from "./ConvergeMerchantId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports